import styled from 'styled-components';

export const RequestProposalContainer = styled.section`
    display: flex;
    flex-direction: column;
    gap: 30px;
    border-radius: 12px;
    background-color: ${({ theme }) => theme.uiBricks?.priceHeaderBackgroundColor || '#F4F4F4'};
    width: 100%;
    box-sizing: border-box;
    align-self: stretch;
`;
